import {observer} from "mobx-react-lite";
import { useContext } from "react";
import { Context } from "../index";
import { Card, Row, Col } from "react-bootstrap";
import '../css/brandbar.css'; 

const BrandBar = observer(() => {
    const {detail} = useContext(Context)
    const handleBrandClick = (brand) => {
        if (detail.selectedBrand.id === brand.id) {
            detail.setSelectedBrand({});
        } else {
            detail.setSelectedBrand(brand);
        }
    };

    return(
        <Row className='d-flex justify-content-center'>
            {detail.brands.map(brand =>
                <Col 
                    xs={6} 
                    sm={4} 
                    md={3} 
                    lg={2} 
                    className="p-2" 
                    key={brand.id}
                > 
                    <Card 
                        active={brand.id === detail.selectedBrand.id ? true : undefined}
                        onClick={() => handleBrandClick(brand)}
                        className={`brand-card ${brand.id === detail.selectedBrand.id ? 'active' : ''}`}
                    >
                        {brand.name}
                    </Card>
                </Col>
            )}
        </Row>
    );
});

export default BrandBar;